//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      loading: true,
      balance: null
    }
  },
  computed: {
    tab() {
      let tab = 'home';
      if (this.$route.name && this.$route.name.includes('sports')) {
        tab = 'sports';
      }
      if (this.$route.name && this.$route.name.includes('live')) {
        tab = 'live';
      }
      if (this.$route.name && this.$route.name.includes('account-bets')) {
        tab = 'account-bets';
      }
      if (this.$route.name && this.$route.name.includes('search')) {
        tab = 'search';
      }

      return tab
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selectionCount() {
      if(this.showBetBuilder)
        return _.size(this.$store.state.betbuilder.selections)
      return _.size(this.selections)
    }
  },
  mounted() {},
  methods: {
    async openMyBets() {
      if (!this.user) {
        this.openLogin();
      } else {
        await this.$router.push(this.localePath('account-bets'))
      }
    },
    async openRegister() {
      this.loadGlobalIframe('open_page', { url: '/registration' })
    },
    async showBetSlip() {
      this.$store.commit('betslip/toggleBetslip', true)
      this.$store.commit('betslip/setProcessingStatus', false)
      this.$root.$emit('show_betslip')
    }
  }
}
